export const summary = {
  textAlign: 'center',
}
